module.exports = __webpack_public_path__ + "img/lagon_4347.87858042.jpg";